import React from "react"
import Layout from "../components/layout"
import Contact from "../components/contact/contact"

export default function Home() {
  return (
    <div style={{ color: `teal` }}>
      <Layout>
      <Contact />
      </Layout>
      
    </div>
  )
}